import React from 'react';
import { combineClassNames } from 'core/css';
import NavButton from './NavButton';

export const GlobalNavButton = ({ className, ...restProps }) => (
  <NavButton
    className={combineClassNames('global-nav__option', className)}
    textClassName="global-nav__option-text"
    {...restProps}
  />
);

export default GlobalNavButton;
